import { render, staticRenderFns } from "./backConfig.vue?vue&type=template&id=ba575318&"
import script from "./backConfig.vue?vue&type=script&lang=js&"
export * from "./backConfig.vue?vue&type=script&lang=js&"
import style0 from "./backConfig.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports